const packageTypes = [
  { display_name: "All", name: "all" },
  { display_name: "Charm", name: "charm" },
  { display_name: "Bundle", name: "bundle" },
];

export default packageTypes;
